import { QueryConfigTypes } from '../../apis-infra';
import { ONE_DAY_IN_MILLISECONDS, ONE_HOUR_IN_MILLISECONDS, ONE_MINUTE_IN_MILLISECONDS } from '../../../constants/constants.time';
export const QUERY_CONFIGS = {
  [QueryConfigTypes.MUTATION_METHOD]: {
    staleTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    optimisticResults: true
  },
  [QueryConfigTypes.REALTIME_DATA]: {
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    refetchOnReconnect: true
  },
  [QueryConfigTypes.REALTIME_NO_REFETCH]: {
    staleTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  },
  [QueryConfigTypes.DYNAMIC_DATA]: {
    staleTime: ONE_MINUTE_IN_MILLISECONDS * 2,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: false
  },
  [QueryConfigTypes.MODERATE_DATA]: {
    staleTime: ONE_MINUTE_IN_MILLISECONDS * 10,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: false,
    optimisticResults: true
  },
  [QueryConfigTypes.STATIC_DATA]: {
    staleTime: ONE_HOUR_IN_MILLISECONDS,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    optimisticResults: true
  },
  [QueryConfigTypes.FIXED_DATA]: {
    staleTime: ONE_DAY_IN_MILLISECONDS,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    optimisticResults: true
  }
};
//# sourceMappingURL=queryConfigTypes.js.map